import React from 'react';
import '../LikeLoaderShimmer/styles.css';
const NotificationShimmer = () =>
{
	return (
		<div className='flexCol'>
			<div className='flexCol whiteBg positonRelative'>
				{[ 1, 2, 3, 4, 5, 6, 7, 8 ].map((e) => (
					<div className='flexCol pdngVXS' key={e}>
						<div className='cardT car-cont bg-white when-NOW p2p style-scope animated_skelton-animate'>
							<div className='row cab-row style-scope animated_skelton-animate'>
								<div className='left cab-icon label style-scope animated_skelton-animate'>
									<div className='icon-placeholder shimmer style-scope animated_skelton-animate' />
								</div>
								<div className='middle holder style-scope animated_skelton-animate'>
									<div className='text2Header-placeholder shimmer style-scope animated_skelton-animate' />
									<div className='text-placeholder titleSecond shimmer style-scope animated_skelton-animate' />
								</div>
							</div>
						</div>
					</div>
				))}

			</div>
		</div>
	);
};

export default NotificationShimmer;
